import React, { createContext } from "react";
export var AuthContext=createContext();
export var OnlineBalance=createContext();
export var OnlineSpent=createContext();
export var OfflineBalance=createContext();
export var OfflineSpent=createContext();
export var Saving=createContext();
export var Theme=createContext();

